import React, { useEffect } from 'react';
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import {
  Box,
  Typography,
  Chip,
  CircularProgress,
  FormControl,
  IconButton,
  Tooltip,
} from '@material-ui/core';

import MyLocationIcon from '@material-ui/icons/MyLocation';
import AssessmentIcon from '@material-ui/icons/Assessment';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ProjectStatusLabel from '../components/ProjectStatusLabel';
import VisibilityIcon from '@material-ui/icons/Visibility';

const useStyles = makeStyles((theme) => ({
  wonProjectCell: {
    padding: '20px 15px',
    width: '100%',
    margin: '20px 0',
    display: 'flex',
    flexDirection: 'column',

    '&:nth-child(2n)': {
      background:
        'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3',
    },
    '& > div': {
      padding: '5px 0',
    },
  },
  cellTitle: {
    fontSize: '1.3rem',
    fontWeight: '700',
  },
  cellNumberAndDistrict: {
    display: 'flex',
    marginLeft: '10px',
    justifyContent: 'space-between',
  },
  cellNumber: {
    color: 'rgba(0, 0, 0, 0.9)',
  },
  cellVotes: {
    color: 'rgba(0, 0, 0, 0.65)',
  },
  cellStatusAndAction: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  maxWidth80: {
    maxWidth: '80%',
  },
  chiptext: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}));

const ProjectItemCard = ({ item }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [tooltipIsOpen, setTooltipIsOpen] = React.useState(false);

  const tooltipHandler = () => {
    setTooltipIsOpen((prev) => !prev);
  };

  return (
    <Box className={classes.wonProjectCell} boxShadow={3}>
      {item?.prize && <div>Miejsce {item.prize}</div>}
      <div className={classes.cellTitle}>{item.title}</div>
      <div className={classes.cellNumberAndDistrict}>
        <div className={classes.cellNumber}>
          <Chip
            label={item.number}
            variant='outlined'
            style={{ backgroundColor: theme.palette.action.hover }}
          />
        </div>
        {item?.district_name && (
          <div className={classes.maxWidth80}>
            <Tooltip
              open={tooltipIsOpen}
              placement='top'
              title={
                <Typography variant='body1'>{item.district_name}</Typography>
              }
            >
              <Chip
                label={<p className={classes.chiptext}>{item.district_name}</p>}
                icon={<MyLocationIcon />}
                variant='outlined'
                style={{ backgroundColor: theme.palette.action.hover }}
                className={classes.width100}
                onClick={tooltipHandler}
              />
            </Tooltip>
          </div>
        )}
      </div>
      <div className={classes.cellVotes}>
        Koszt po weryfikacji: {item.estimate}
      </div>
      <div className={classes.cellStatusAndAction}>
        <div>
          <ProjectStatusLabel
            status={item.status}
            classes={classes}
            theme={theme}
          ></ProjectStatusLabel>
        </div>
        <div>
          <IconButton
            href={`${previewUrl}?projectId=${item.id}`}
            title='Podgląd'
            aria-label='Podgląd'
          >
            <VisibilityIcon />
          </IconButton>
        </div>
      </div>
    </Box>
  );
};

export default ProjectItemCard;
